import { usePortSnapshot } from '@/hooks/usePortSnapshot';
import type { EditorRuntimePorts } from '@/ports/runtime';
import { EditorScreen } from './components/EditorScreen';
import { RecoveryScreen } from './components/RecoveryScreen';
import { SetupScreen } from './components/SetupScreen';

export function App({ runtime }: { readonly runtime: EditorRuntimePorts }) {
  const snapshot = usePortSnapshot(runtime.editor);
  if (snapshot.recoveryDraft) {
    return (
      <RecoveryScreen
        draft={snapshot.recoveryDraft}
        onContinue={() => runtime.editor.continueRecoveredDraft()}
        onNew={() => runtime.editor.startNewFromRecovery()}
      />
    );
  }
  return snapshot.document ? <EditorScreen runtime={runtime} /> : <SetupScreen editor={runtime.editor} />;
}
